module.exports = __webpack_public_path__ + "img/rosepetal-dep-barinsa.066171be.jpg";